import React from 'react';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from '../common/enumerations/emerald-dialog-types';
import { PromotionApprovalQuantityModal } from './promotion-approval-quantity-picker';

export const showPromotionApprovalDialog = (props: PromotionApprovalProps) => {
  const { pendingRedemptionCount } = props;
  pendingRedemptionCount > 1
    ? showPromotionApprovalQuantityModal(props)
    : showPromotionApprovalModal(props);
};

export const showPromotionApprovalQuantityModal = (props: PromotionApprovalProps): void => {
  pushEmeraldModal(<PromotionApprovalQuantityModal {...props} />);
};

const showPromotionApprovalModal = (props: PromotionApprovalProps): void => {
  const modalConfig: IMessageModal = {
    type: EmeraldDialogTypes.InfoDecision,
    message: 'PromotionApproval_Caption',
    subMessage: 'PromotionApprovalMessagePrefix',
    onAccept: () => {
      props.resolvePromotion({ isApproved: true });
      popEmeraldModal();
    },
    onCancel: () => {
      props.resolvePromotion({ isApproved: false });
      popEmeraldModal();
    },
    disableBackdropClick: true,
    acceptButtonLabel: 'PromotionApproval_Apply',
    closeButtonLabel: 'PromotionApproval_DoNotApply',
    subMessageArgs: { arg: props.approvalMessage ?? '' },
  };

  showEmeraldDialog(modalConfig);
};

export interface PromotionApprovalProps {
  approvalMessage: string;
  pendingRedemptionCount: number;
  resolvePromotion: (value: { isApproved: boolean; authorizedCount?: number }) => void;
}
